import React, {memo} from 'react'
import {Header} from 'semantic-ui-react'
import {atServiceLimit, getPublishedOrFirstVersion} from '../../util'
import {
  withErrorHandling,
  withHelmet,
  withPropsPresent,
  withServiceData,
  withServicesData,
  withMeData
} from '../../hoc'
import {Actions} from '../shared'
import {cloneService} from '../../backend'
import {useSafeState} from '../../hook'

const _Service = (
  {
    me,
    service,
    navigate,
    cloneService,
    mutateServices,
    mutateMe,
    children,
    basePath = '/c/services'
  }
) => {
  const version = getPublishedOrFirstVersion(service)

  const [state, setState] = useSafeState({cloning: false})

  const onEditService = () => {
    navigate(`${basePath}/${service.id}/edit`)
  }

  const onRemoveService = () => {
    navigate(`${basePath}/${service.id}/remove`)
  }

  const onArchiveService = () => {
    navigate(`${basePath}/${service.id}/archive`)
  }

  const onCloneService = async () => {
    setState({...state, cloning: true})
    const cloned = await cloneService(service.id)
    setState({...state, cloning: false})
    const version = getPublishedOrFirstVersion(cloned)
    mutateServices()
    mutateMe()
    if (!version) {
      navigate(`${basePath}/${cloned.id}/versions`)
      return
    }
    navigate(`${basePath}/${cloned.id}/versions/${version.id}/environments`)
  }

  const onBrowseServiceDocs = async () => {
    navigate(`/c/directory/services/${service.id}/versions/${version.id}/display/oas`)
  }

  const actions = {
    onViewDocs: onBrowseServiceDocs,
    onEdit: onEditService,
    onClone: atServiceLimit(me) ? undefined : () => onCloneService(),
    onRemove: onRemoveService,
    onArchive: onArchiveService
  }

  if(!version) {
    delete actions.onViewDocs
  }

  return (
    <div data-testid='service-container'>
      <div>
        <Header as='h1' style={{float: 'left'}}>{service.name}</Header>
        <Actions
          prefix='service'
          style={{float: 'right'}}
          {...actions}
        />
        <div style={{clear: 'both'}}/>
      </div>
      {children}
    </div>
  )
}

let Service = (props) => {
  const {handleError} = props
  props = {...props, cloneService: handleError(cloneService)}
  return (
    <_Service {...props}/>
  )
}
Service = withHelmet(Service, (props) => {
  const {service} = props
  if (service) {
    return `Service - ${service.name}`
  }
})
Service = withPropsPresent(Service, ['service', 'me'])
Service = withServiceData(Service, 'Loading service...')
Service = withServicesData(Service, 'Loading services...')
Service = withMeData(Service, 'Loading profile...')
Service = withErrorHandling(Service)
Service = memo(Service)


export {_Service, Service}

export default Service